import React from 'react';
import { Formik } from 'formik';
import {
    TextField,
    withStyles,
    Select,
    MenuItem,
    FormControl,
    Button,
    InputLabel,
    CircularProgress
} from '@material-ui/core';
import * as Yup from 'yup';
import ProductTypePanels from './ProductTypePanels';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    button: {
        width: '120px',
        marginTop: '10px',
        marginRight: '10px'
    },
    formControl: {
        width: '100%'
    }
});

const FormStep1StoreExternalData = props => {
    const {
        classes,
        formSettings,
        initialValues,
        translations,
        isDirty,
        edit,
        handleSubmit
    } = props;

    initialValues.Direction = 'in';

    delete initialValues.ServiceType;
    delete initialValues.Hostname;
    delete initialValues.Protocol;
    delete initialValues.AuthType;
    delete initialValues.Port;
    delete initialValues.UseExternalTypicalProblems;
    delete initialValues.DatabaseName;
    delete initialValues.TableName;
    delete initialValues.Username;
    delete initialValues.Password;
    delete initialValues.BearerToken;
    delete initialValues.ApiKey;
    delete initialValues.ClientID;
    delete initialValues.ClientSecret;
    delete initialValues.ClientIDHeaderName;
    delete initialValues.ClientIDHeaderValue;
    delete initialValues.ClientSecretHeaderName;
    delete initialValues.ClientSecretHeaderValue;
    delete initialValues.CustomMapping;
    delete initialValues.TableMapping;
    delete initialValues.Path;
    delete initialValues.TriggerOnSessionStart;
    delete initialValues.TriggerOnModifiedWeb;
    delete initialValues.TriggerOnModifiedProcessing;
    delete initialValues.TriggerOnErasureProgress;
    delete initialValues.TriggerOnErasureFinished;
    delete initialValues.TriggerOnDiagnoseFinished;
    delete initialValues.TriggerOnSessionEnd;
    delete initialValues.TriggerOnAnalyzeFinished;
    delete initialValues.TriggerOnOperatorWorkflowDone;
    delete initialValues.TriggerOnReportGenerated;
    delete initialValues.SendReportOnSuccessfulErasure;
    delete initialValues.SendReportOnFailedErasure;
    delete initialValues.SendReportOnNoErasure;
    delete initialValues.OutputFormat;
    delete initialValues.AutostartErasureOnMethodEnabled;
    delete initialValues.ConfirmDataExportEnabled;
    delete initialValues.ConfirmDataExportMessage;
    delete initialValues.SendErasureReportEndpoint;
    delete initialValues.ErasureMethodMapping;
    delete initialValues.SendReportMethod;

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={Yup.object().shape(formSettings.Validation)}
            onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(true);
                await handleSubmit(values);
            }}
            validateOnMount={true}
        >
            {formikProps => {
                const { values, dirty, touched, errors, isValid, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;

                return (
                    <div className={classes.root}>
                        <form onSubmit = {handleSubmit}>
                            <>
                                <TextField
                                    name="Name"
                                    value={values.Name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={!!(errors.Name && touched.Name)}
                                    placeholder={translations["name"] || "Name"}
                                    label={translations["name"] || "Name"}
                                    margin={"dense"}
                                    fullWidth={true}
                                />
                                <FormControl id="active_select" className={classes.formControl} margin={"dense"}>
                                    <InputLabel shrink>{translations["active"] || "Active"}</InputLabel>
                                    <Select
                                        name="Active"
                                        value={values.Active}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={!!(errors.Active && touched.Active)}
                                        placeholder={translations["active"] || "Active"}
                                        label={translations["active"] || "Active"}
                                        margin={"dense"}
                                        fullWidth={true}
                                    >
                                        <MenuItem value={true}>
                                            {translations['active'] || 'Active'}
                                        </MenuItem>
                                        <MenuItem value={false}>
                                            {translations['inactive'] || 'Inactive'}
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                                <ProductTypePanels
                                    externalType={values.Type}
                                    translations={translations}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                />
                            </>
                            {formSettings.ButtonSubmit ? (
                                <Button
                                    className={classes.submit}
                                    variant="contained"
                                    color={formSettings.ButtonSubmit.Color}
                                    type="submit"
                                    disabled={!edit ? !isValid || isSubmitting : !((isValid && dirty) || isDirty) || isSubmitting}
                                >
                                    {isSubmitting ? (
                                        <CircularProgress size={24} />
                                    ) : (
                                            formSettings.ButtonSubmit.Title
                                        )}
                                </Button>
                            ) : null}
                        </form>
                    </div>
                );
            }}
        </Formik >
    );
};

export default withStyles(styles, { withTheme: true })(FormStep1StoreExternalData);